module.exports = __webpack_public_path__ + "static/img/second_bg_h5.6f89696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/second_bg_h5.png
// module id = SGp3
// module chunks = 34